import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Land')

export default {
  label: 'Land',
  route: 'land',
  className: 'land',
  fields: [
    ListFields.SortableReference('alpha2code', true),
    ListFields.SortableReference('alpha3code', true),
    ListFields.SortableReference('nameDE', true),
    ListFields.SortableReference('nameEN', true),
    ListFields.SortableReference('numericCode', true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Land.js